import { ISpasProblem } from '@r1-frontend/api-domru/api-profile/v1/spas/index';
import { IResponseRequest, TRequestType } from '@r1-frontend/api-domru/core-requests/api/v1/service';

import { THydrateAction } from '~/src/store';
import * as ActionCreators from '~/src/store/actionCreators/spas';
import {
    SPAS_INFO_LOAD_ERROR,
    SPAS_INFO_LOADED,
    SPAS_INFO_LOADING,
    SPAS_SERVICE_REQUEST_LOAD_ERROR,
    SPAS_SERVICE_REQUEST_LOADED,
    SPAS_SERVICE_REQUEST_LOADING,
} from '~/src/store/actionTypes/spas';

export interface ISpasRequest {
    isLoading: boolean,
    loaded: number | null,
    canCreateRequest: boolean,
    requestType: TRequestType | null,
    request: IResponseRequest | null,
}

export interface ISpasStore {
    problem: {
        isLoading: boolean,
        loaded: number | null,
        spasInfo: ISpasProblem[],
    },
    request: ISpasRequest,
}

const initialState: ISpasStore = {
    problem: {
        isLoading: false,
        loaded: null,
        spasInfo: [],
    },
    request: {
        isLoading: false,
        loaded: null,
        canCreateRequest: false,
        requestType: null,
        request: null,
    },
};

// автоматически собераем все типы ActionCreator
type InferValueTypes<T> = T extends { [key: string]: infer U } ? U : never;
// достаем возвращаемое значения из ActionCreator
type TActions = ReturnType<InferValueTypes<typeof ActionCreators>>

export default function(state = initialState, action: TActions | THydrateAction): ISpasStore {
    switch (action.type) {
        case SPAS_INFO_LOADING:
            return {
                ...state,
                problem: {
                    ...state.problem,
                    isLoading: true,
                },
            };
        case SPAS_INFO_LOADED:
            return {
                ...state,
                problem: {
                    ...state.problem,
                    spasInfo: action.payload,
                    loaded: (new Date()).getTime(),
                    isLoading: false,
                },
            };
        case SPAS_INFO_LOAD_ERROR:
            return {
                ...state,
                problem: {
                    ...state.problem,
                    isLoading: false,
                },
            };
        case SPAS_SERVICE_REQUEST_LOADING:
            return {
                ...state,
                request: {
                    ...state.request,
                    isLoading: true,
                },
            };
        case SPAS_SERVICE_REQUEST_LOADED:
            return {
                ...state,
                request: {
                    ...state.request,
                    isLoading: false,
                    loaded: (new Date()).getTime(),
                    canCreateRequest: action.payload.canCreateRequest === 1,
                    requestType: action.payload.requestType,
                    request: action.payload.request,
                },
            };
        case SPAS_SERVICE_REQUEST_LOAD_ERROR:
            return {
                ...state,
                request: {
                    ...state.request,
                    isLoading: false,
                },
            };
        default:
            return state;
    }
}
